import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { addDisplayName } from "../Infra/display-name";
import { PatientConsentPDDEGDUBaseAnimatingComponent } from "./PatientConsentPDDEGDUBaseAnimatingComponent";
import { StepsContainer, StepRow, StepIconContainer, StepTextContainer, StepText, DividerContainer, DividerLineWrapper, DividerLine, CheckIcon, } from "./DocumentRetrievalRecordsShared.styles";
import { ConfirmButton, FooterPlaceholderButton } from "./PatientConsentManagerShared.styles";
import DomainAddIcon from "@mui/icons-material/DomainAdd";
export const DocumentRetrievalRecordsFound = observer((props) => {
    const { t } = useTranslation(["patients"]);
    const { isIAS, animate } = props;
    const shareRecordsText = isIAS
        ? t("Review and access your records")
        : props.isAIFlow
            ? t("Review and connect your records")
            : t("Review and share your records");
    const steps = [
        {
            id: "identity-verified",
            text: t("Identity verified"),
            isCompleted: true,
            isActive: false,
        },
        {
            id: "access-confirmed",
            text: props.isDataUpdate ? t("Records found") : t("Access confirmed and records found"),
            isCompleted: true,
            isActive: false,
        },
        {
            id: "review-share",
            text: shareRecordsText,
            isCompleted: false,
            isActive: true,
        },
    ];
    return (_jsx(PatientConsentPDDEGDUBaseAnimatingComponent, { title: t("Records found!"), supportingText: props.isIAS
            ? t("We've found your records. Next, review what we've found.")
            : props.isAIFlow
                ? t("We’ve found your records. Next, review and connect what we’re found.")
                : t("We've found your records. Next, review and share what we've found."), animate: animate, buttons: _jsxs(_Fragment, { children: [_jsx(ConfirmButton, { onClick: () => { var _a; return (_a = props.onContinue) === null || _a === void 0 ? void 0 : _a.call(props); }, children: t("Continue") }), _jsx(FooterPlaceholderButton, {})] }), children: (isAnimating) => (_jsx(StepsContainer, { isAnimating: isAnimating, animate: animate, children: steps.map((step, index) => (_jsxs(React.Fragment, { children: [_jsxs(StepRow, { children: [_jsx(StepIconContainer, { isActive: step.isActive, isCompleted: step.isCompleted, children: step.isCompleted ? _jsx(CheckIcon, {}) : _jsx(DomainAddIcon, {}) }), _jsx(StepTextContainer, { isCompleted: step.isCompleted, children: _jsx(StepText, { isActive: step.isActive, children: step.text }) })] }), index < steps.length - 1 && (_jsxs(DividerContainer, { children: [_jsx(DividerLineWrapper, {}), _jsx(DividerLine, {})] }))] }, step.id))) })) }));
});
addDisplayName(DocumentRetrievalRecordsFound, "DocumentRetrievalRecordsFound");
